import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';

import CategoryIcon from '@mui/icons-material/Category';
import PeopleIcon from '@mui/icons-material/People';
import AdUnitsIcon from '@mui/icons-material/AdUnits';
import BookOnlineIcon from '@mui/icons-material/BookOnline';


import colors from '../../styles/colors';
import { Icons } from '../../assets/Svgs'; // Replace with relevant icons for new data
import { useFetchDashboardStatsQuery } from '../../store/services/dashboardService';
import Loader from '../../components/Loader';

const Dashboard = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Fetch data from the API
    const { data, isLoading, isError } = useFetchDashboardStatsQuery();
    const [stats, setStats] = useState({
        totalCategories: 0,
        totalUsers: 0,
        userGrowthPercentage: "0%",
        totalAds: 0,
        totalBookings: 0,
        bookingGrowthPercentage: "0%",
    });

    useEffect(() => {
        if (data?.status === 1) {
            const dashboardData = data.data;
            setStats({
                totalCategories: dashboardData.total_categories || 0,
                totalUsers: dashboardData.total_users || 0,
                userGrowthPercentage: `${dashboardData.user_growth_percentage}%` || "0%",
                totalAds: dashboardData.total_ads || 0,
                totalBookings: dashboardData.total_bookings || 0,
                bookingGrowthPercentage: `${dashboardData.booking_growth_percentage}%` || "0%",
            });
        }
    }, [data]);

    const cards = [
        {
            title: 'Total Categories',
            value: stats.totalCategories,
            percentage: 'N/A',
            icon: CategoryIcon, // Material-UI icon for categories
        },
        {
            title: 'Total Users',
            value: stats.totalUsers,
            percentage: stats.userGrowthPercentage,
            icon: PeopleIcon, // Material-UI icon for users
        },
        {
            title: 'Total Ads',
            value: stats.totalAds,
            percentage: 'N/A',
            icon: AdUnitsIcon, // Material-UI icon for ads
        },
        {
            title: 'Total Bookings',
            value: stats.totalBookings,
            percentage: stats.bookingGrowthPercentage,
            icon: BookOnlineIcon, // Material-UI icon for bookings
        },
    ];



    if (isError) return <Typography>Error loading dashboard data.</Typography>;

    return (
        <div style={{ backgroundColor: colors.bg }}>
            <Box sx={{ padding: '16px' }}>
                {/* Top Stats */}
                <Grid container spacing={isMobile ? 2 : 4}>
                    {cards.map((item, index) => {
                        const Icon = item.icon;
                        return (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        padding: '8px',
                                        borderRadius: '16px',
                                        backgroundColor: 'white',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        height: '100%',
                                    }}
                                >
                                    {/* Icon */}
                                    <Box
                                        sx={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '50%',
                                            backgroundColor: colors.primary,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginRight: '16px',
                                        }}
                                    >
                                        <Icon />
                                    </Box>
                                    {/* Text */}
                                    <Box sx={{ flexGrow: 1 }}>
                                        <Typography variant="body2" sx={{ color: '#A098AE', fontFamily: 'PRe' }}>
                                            {item.title}
                                        </Typography>
                                        <Typography variant="h6" sx={{ color: '#000000', fontFamily: 'PSBo', marginTop: '3px' }}>
                                            {item.value}
                                        </Typography>
                                        {item.percentage !== 'N/A' && (
                                            <Typography variant="body2" sx={{ color: '#A098AE', marginTop: '3px', fontFamily: 'PMe' }}>
                                                {item.percentage} Than Last Month
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
            <Loader open={isLoading} />
        </div>
    );
};

export default Dashboard;





// import React, { useState, useEffect } from 'react';
// import { Box, Grid, Pagination, Typography, useMediaQuery, useTheme } from '@mui/material';
// import colors from '../../styles/colors';
// import { Icons } from '../../assets/Svgs';
// import VehicleCard from './VehicleViewComponent';
// import { useFetchDashboardStatsQuery } from '../../store/services/dashboardService';

// const Dashboard = () => {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     // Fetch data from the API
//     const { data, isLoading, isError } = useFetchDashboardStatsQuery();
//     const [stats, setStats] = useState({
//         totalClients: 0,
//         clientChange: "0%",
//         totalContracts: 0,
//         contractChange: "0%",
//         totalSales: "0 OMR",
//         salesChange: "0%",
//         totalProfits: "0 OMR",
//         profitChange: "0%",
//         carsReturningToday: [],
//         availableCars: []
//     });

//     useEffect(() => {
//         if (data?.status === "1") {
//             const dashboardData = data.data;
//             setStats({
//                 totalClients: dashboardData.total_clients || 0,
//                 clientChange: `${dashboardData.client_change}%` || "0%",
//                 totalContracts: dashboardData.total_contracts || 0,
//                 contractChange: `${dashboardData.contract_change}%` || "0%",
//                 totalSales: `${dashboardData.total_sales} OMR` || "0 OMR",
//                 salesChange: `${dashboardData.sales_change}%` || "0%",
//                 totalProfits: `${dashboardData.total_profits} OMR` || "0 OMR",
//                 profitChange: `${dashboardData.profit_change}%` || "0%",
//                 carsReturningToday: dashboardData.cars_returning_today || [],
//                 availableCars: dashboardData.availableVehicles || []
//             });
//         }
//     }, [data]);

//     const cards = [
//         {
//             title: 'Total Users',
//             value: stats.totalClients,
//             percentage: stats.clientChange,
//             icon: Icons.clientsDIcon,
//         },
//         {
//             title: 'Total Bookings',
//             value: stats.totalSales,
//             percentage: stats.salesChange,
//             icon: Icons.totalSalesIcon,
//         },
//         {
//             title: 'Total Profits',
//             value: stats.totalProfits,
//             percentage: stats.profitChange,
//             icon: Icons.totalProfitsIcon,
//         },
//     ];

//     if (isLoading) return <Typography>Loading...</Typography>;
//     if (isError) return <Typography>Error loading dashboard data.</Typography>;

//     return (
//         <div style={{ backgroundColor: colors.bg }}>
//             <Box sx={{ padding: '16px' }}>
//                 {/* Top Stats */}
//                 <Grid container spacing={isMobile ? 2 : 4}>
//                     {cards.map((item, index) => {
//                         const Icon = item.icon;
//                         return (
//                             <Grid item xs={12} sm={6} md={3} key={index}>
//                                 <Box
//                                     sx={{
//                                         display: 'flex',
//                                         flexDirection: 'row',
//                                         alignItems: 'center',
//                                         padding: '8px',
//                                         borderRadius: '16px',
//                                         backgroundColor: 'white',
//                                         boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//                                         height: '100%',
//                                     }}
//                                 >
//                                     {/* Icon */}
//                                     <Box
//                                         sx={{
//                                             width: '50px',
//                                             height: '50px',
//                                             borderRadius: '50%',
//                                             backgroundColor: colors.primary,
//                                             display: 'flex',
//                                             justifyContent: 'center',
//                                             alignItems: 'center',
//                                             marginRight: '16px',
//                                         }}
//                                     >
//                                         <Icon />
//                                     </Box>
//                                     {/* Text */}
//                                     <Box sx={{ flexGrow: 1 }}>
//                                         <Typography variant="body2" sx={{ color: '#A098AE', fontFamily: 'PRe' }}>
//                                             {item.title}
//                                         </Typography>
//                                         <Typography variant="h6" sx={{ color: '#000000', fontFamily: 'PSBo', marginTop: '3px' }}>
//                                             {item.value}
//                                         </Typography>
//                                         <Typography variant="body2" sx={{ color: '#A098AE', marginTop: '3px', fontFamily: 'PMe' }}>
//                                             {item.percentage} Than Last Month
//                                         </Typography>
//                                     </Box>
//                                 </Box>
//                             </Grid>
//                         );
//                     })}
//                 </Grid>
//             </Box>
//         </div>
//     );
// };

// export default Dashboard;